module.exports = __webpack_public_path__ + "static/never_split_the_difference-73fbcc4ebd5b60520e26a8362dcba421.webp";